import { render, staticRenderFns } from "./HintResources.vue?vue&type=template&id=7081e36e&scoped=true"
import script from "./HintResources.vue?vue&type=script&lang=js"
export * from "./HintResources.vue?vue&type=script&lang=js"
import style0 from "./HintResources.vue?vue&type=style&index=0&id=7081e36e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7081e36e",
  null
  
)

export default component.exports